import React, { useCallback, useEffect, useState } from "react"
import { CSSTransition } from "react-transition-group"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"
import Scroll from "@hg/scroll"

import Toast from "@/topic/rogue_4/components/Toast"
import { i18n } from "@/utils/i18n"
import { draw } from "../../../service"
import { useGameStore } from "../../../store"
import { SFX } from "../../../utils/sound"
import { getTransitionClassnames } from "../../../utils/transition"
import Button from "../../Button"
import ModalTitle from "../common/modalTitle"
import { useGameModalStore, useGameRollModal } from "../store"

import styles from "./index.module.less"

const RuleModal: StyledComponent = ({ className, style }) => {
    const [active, setActive] = useState(false)
    const rolled = useGameStore((state) => state.rolled)

    useEffect(() => {
        useGameModalStore.setState({
            callRuleModal: () => {
                setButtonActive(rolled)
                setActive(true)
            },
        })
    }, [rolled])
    const [buttonActive, setButtonActive] = useState(false)
    const [loading, setLoading] = useState(false)
    const callRollModal = useGameRollModal()
    const handleConfirm = useCallback(async () => {
        SFX.play("commonClick")
        if (loading) {
            return
        }
        if (buttonActive) {
            setActive(false)
        } else {
            setLoading(true)
            const { code, data, msg } = await draw()
            if (code === 0) {
                useGameStore.setState({
                    rolled: true,
                    rollResult: { bingo: data.bingo, giftKey: data.awardId },
                })
                callRollModal()
                setTimeout(() => {
                    setActive(false)
                    setLoading(false)
                }, 300)
            } else {
                setActive(false)
                Toast.message({ content: msg })
                setLoading(false)
            }
        }
    }, [loading, buttonActive, callRollModal])
    return (
        <CSSTransition
            in={active}
            timeout={300}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                className={classNames(styles.ruleModal, className)}
                style={style}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <div className={styles.doors}>
                    <div className={styles.leftDoor}></div>
                    <div className={styles.rightDoor}></div>
                </div>
                <div className={styles.maskBottom}></div>
                <ModalTitle className={styles.title}>
                    {i18n(i18nData, "rogue_4.game.title.roll.rule")}
                </ModalTitle>
                <Scroll
                    direction="y"
                    className={styles.scrollContainer}
                    scrollBarClassName={styles.scrollBar}
                    thumbClassName={styles.thumb}
                    autoHideScrollBar={false}
                    scrollBar
                    rotateDetection
                >
                    <div
                        className={styles.contentContainer}
                        dangerouslySetInnerHTML={{
                            __html: i18n(
                                i18nData,
                                "rogue_4.game.roll.rule.content"
                            ),
                        }}
                    ></div>
                </Scroll>
                <Button
                    active={false}
                    className={styles.backButton}
                    onClick={handleConfirm}
                    size="small"
                >
                    {!buttonActive
                        ? i18n(i18nData, "rogue_4.game.roll.confirmRoll")
                        : i18n(i18nData, "rogue_4.game.roll.confirm")}
                </Button>
            </div>
        </CSSTransition>
    )
}

export default RuleModal
